// extracted by mini-css-extract-plugin
export default {"wrapper":"pB-z","addressLine":"qB-z","fullName":"rB-z"};